<template>
  <div v-show="isMarked">
    <div id="marked-mask"></div>
    <div id="marked">
      <div id="marked-title">
        <h2><span></span>标记信息</h2>
        <i @click="handleVoice"></i>
        <button @click="closeMarked">×</button>
      </div>
      <p>当前位置：东莞市松山湖大学路3号东莞职业技术学院</p>
      <!-- 标记地址 -->
      <div class="marked-park">
        <h2><span></span>标记地址</h2>
        <input ref="addressDOM" type="text" v-model="address" />
        <button
          class="text-copy"
          @click="copyInfo(address, '文本为空，请手动输入地址后进行复制')"
        >
          
        </button>
        <button class="text-edit" @click="handleReadOnly"></button>
      </div>
      <!-- 约定时间 -->
      <div class="marked-park">
        <h2><span></span>约定时间</h2>
        <input
          type="datetime-local"
          @change="changeDate($event)"
          :value="selectTime"
        />
        <span class="apart-time" v-show="selectTime">{{ ApartTime }}</span>
        <button
          class="text-copy"
          @click="copyInfo(selectTime, '请先填写约定时间后再进行复制~')"
        >
          
        </button>
      </div>
      <!-- 全景图 -->
      <div class="marked-park">
        <h2><span></span>全景图</h2>
        <input type="text" readonly />
        <a :href="panorama" target="_blank">{{
          panorama == 0 ? "该地点暂无全景图" : "点此跳转到全景图"
        }}</a>
        <button
          class="text-copy"
          @click="copyInfo(panorama, '链接为空，没有找到该全景图的URL')"
        >
          
        </button>
      </div>
      <!-- 留言 -->
      <div class="marked-park">
        <h2><span></span>留言</h2>
        <textarea type="text" v-model="userMessage" />
        <button
          class="text-edit"
          @click="copyInfo(userMessage, '请先填写留言后再进行复制~')"
        >
          
        </button>
      </div>
      <div class="marked-opera">
        <button id="link-copy" @click="copyMarkedLink">
          <span></span> 复制标记链接
        </button>
        <button id="link-share"><span></span> 分享</button>
        <button id="marked-save" @click="copyMarkedLink" v-show="isShare">
          <span></span> 保存标记
        </button>
      </div>
    </div>
    <Voice :voiceData="voicedata" ref="voice" v-if="voicedata != ''" />
  </div>
</template>

<script scoped>
import Voice from "./Voice.vue";
import { formatTime } from "@/assets/js/formatTime";
export default {
  name: "Marked",
  components: {
    Voice,
  },
  props: ["address", "panorama", "point", "userMessage", "isShare"],
  data() {
    return {
      voicedata: "",
      // userMessage: "",
    };
  },
  methods: {
    handleVoice() {
      this.voicedata = "";
      this.voicedata = this.getVoiceData;
      if (this.selectTime == "" || this.address == "") {
        alert("需要先填好信息！");
        return false;
      }
      if (this.address == "没有找到地址信息，请手动输入。") {
        alert("请输入好地址信息！");
        return false;
      }
      console.log(this.voicedata);
      if (this.voicedata == "") {
        console.log(this.voicedata);
        alert("error!");
        return false;
      }
    },
    copyMarkedLink() {
      let _this = this;
      let oURI = document.createElement("input");
      let point = _this.point;
      let address = _this.address;
      let pmtime = _this.selectTime;
      let panorama = _this.panorama;
      this.$http
        .post("/service/addshare", {
          type: "one",
          point: point,
          address: address,
          apartTime: pmtime,
          panorama: panorama,
          info: _this.userMessage,
        })
        .then(function (oRes) {
          oRes = oRes.data;
          var link = `http://map.ayane.io/?ms=${oRes.id}`;
          _this.closeMarked();
          _this.$emit("openCopyCard", link);
        });
    },
    closeMarked() {
      this.$store.dispatch("toggleMarked");
    },
    // 文本复制
    copyInfo(domInput, errorBack) {
      if (domInput == "") {
        alert(errorBack);
      } else {
        var input = document.createElement("input");
        input.value = domInput;
        document.body.appendChild(input);
        input.select();
        document.execCommand("Copy");
        document.body.removeChild(input);
        alert("复制成功");
      }
    },
    // 时间戳Conver
    getApartTime(dateTime) {
      // 指定日期和时间
      var EndTime = new Date(dateTime);
      // 当前系统时间
      var NowTime = new Date();
      var t = EndTime.getTime() - NowTime.getTime();
      var d = Math.floor(t / 1000 / 60 / 60 / 24);
      var h = Math.floor((t / 1000 / 60 / 60) % 24);
      var m = Math.floor((t / 1000 / 60) % 60);
      // var s = Math.floor((t / 1000) % 60);
      var html = "距离约定时间还有 " + d + " 天 " + h + " 时 " + m + " 分";
      return html;
    },
    // 获取距离约定时间剩余时间
    changeDate(e) {
      this.$store.dispatch("bindTime", e.target.value);
    },
    // 随机字符串生成 (字母+数字)
    randomWord(randomFlag, min, max) {
      var str = "",
        range = min,
        arr = [
          "0",
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "a",
          "b",
          "c",
          "d",
          "e",
          "f",
          "g",
          "h",
          "i",
          "j",
          "k",
          "l",
          "m",
          "n",
          "o",
          "p",
          "q",
          "r",
          "s",
          "t",
          "u",
          "v",
          "w",
          "x",
          "y",
          "z",
          "A",
          "B",
          "C",
          "D",
          "E",
          "F",
          "G",
          "H",
          "I",
          "J",
          "K",
          "L",
          "M",
          "N",
          "O",
          "P",
          "Q",
          "R",
          "S",
          "T",
          "U",
          "V",
          "W",
          "X",
          "Y",
          "Z",
        ];
      if (randomFlag) {
        range = Math.round(Math.random() * (max - min)) + min;
      }
      for (let i = 0; i < range; i++) {
        let pos = Math.round(Math.random() * (arr.length - 1));
        str += arr[pos];
      }
      return str;
    },
    // 写cookie
    addCookie() {
      // TODO:
      let _this = this;
      let cookieArr = new Object(); // Cookies 数组对象
      let cookieName = "marked" + _this.randomWord(false, 8); // Cookie 名称
      let cookieAddress = _this.address; /// Cookie 标记地点
      let cookiePoint = _this.point; // Cookie 坐标点
      let cookieTime = _this.selectTime; // Cookie 约定时间
      let cookieURL = _this.panorama; // Cookie 全景图URL
      let cookieUserMessage = _this.userMessage; // Cookie 备注/留言
      cookieArr.name = cookieName;
      cookieArr.address = cookieAddress;
      cookieArr.point = cookiePoint;
      cookieArr.time = cookieTime;
      cookieArr.url = cookieURL;
      cookieArr.info = cookieUserMessage;
      cookieArr.type = "one";
      _this.$cookies.set(cookieName, cookieArr, "30d");
      alert("保存成功");
      _this.closeMarked();
    },
    handleReadOnly() {
      this.$refs.addressDOM.select();
    },
  },
  computed: {
    isMarked() {
      return this.$store.state.isMarked;
    },
    selectTime() {
      return this.$store.state.selectTime;
    },
    ApartTime() {
      let promiseTime = this.selectTime;
      let resTime = this.getApartTime(promiseTime);
      return resTime;
    },
    getVoiceData() {
      return `约定好${formatTime(this.selectTime)}到达${this.address},${
        this.ApartTime
      }`;
    },
  },
};
</script>

<style lang="less" scoped>
@import "../assets/less/Marked.less";
</style>
